import CommonRadioMulSelect from '../CommonRadioMulSelect';
import React from 'react';
import { get } from 'lodash';
import { Select } from 'src/components/Antd/Select';
const Option = Select.Option;
const OptGroup = Select.OptionGroup;
const TernsAndConditions = (props) => {
  const {
    selectOptions,
    radioName,
    selectName,
    noStyle,
    disabled,
    hasExclude,
  } = props;
  return (
    <CommonRadioMulSelect
      selectOptions={selectOptions}
      radioName={radioName}
      selectName={selectName}
      noStyle={noStyle}
      hasExclude={hasExclude}
      disabled={disabled}
      generateOptions={(options = []) => {
        return options
          .filter((i) => (get(i, 'termConditions') || []).length > 0)
          .map((i) => {
            const salesChannelName = get(i, 'salesChannelName');
            const termConditions = get(i, 'termConditions') || [];
            return (
              <OptGroup label={salesChannelName}>
                {termConditions.map((t) => {
                  const name = get(t, 'name');
                  const uuid = get(t, 'uuid');
                  return (
                    <Option value={uuid} key={uuid}>
                      {name}
                    </Option>
                  );
                })}
              </OptGroup>
            );
          });
      }}
    />
  );
};
export default TernsAndConditions;
